<template>
  <Modal
    extra-class="dea-modal--refer dea-modal--no-footer"
    :has-full-width="modalFullWidth"
    :visible="visible"
    @modal-close="$emit('modal-close')"
  >
    <template #title>
      Come dobbiamo riferirci a te?
    </template>
    <template #content>
      <CheckboxList label="Scegli la frase in cui ti rispecchi di più:">
        <Checkbox
          v-for="(sentence, index) in referSentences[user.role]"
          :id="`checkbox-${index}`"
          :key="index"
          class="dea-checkbox--regular"
          :checked="user.gender === sentence.value"
          name="sentence"
          type="radio"
          :value="sentence.value"
          @change="changeValue($event)"
        >
          {{ sentence.label }}
        </Checkbox>
      </CheckboxList>
      <Buttons
        class="dea-button--large"
        :disabled="!selectedSentence"
        @click="$emit('user-update', { gender: selectedSentence })"
      >
        Salva modifiche
      </Buttons>
    </template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import Checkbox from "@/components/elements/Checkbox";
import CheckboxList from "@/components/patterns/CheckboxList";
import Modal from "@/components/patterns/Modal";
import variables from "@/styles/variables.scss";
import windowResize from "@/components/mixins/handleWindowResize";
import referSentences from "../helpers/referSentences";

export default {
  name: "ReferModal",
  components: { Buttons, Checkbox, CheckboxList, Modal },
  mixins: [windowResize],
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedSentence: this.user.gender,
      sentences: [
        "Professoressa, è già stata a un nostro Convegno?",
        "Professore, è già stato a un nostro Convegno?",
        "Prof., è già stat* a un nostro Convegno?",
      ],
      referSentences,
    };
  },
  computed: {
    modalFullWidth() {
      return this.windowWidth <= variables.bpSizeSmall;
    },
  },
  methods: {
    changeValue(event) {
      this.selectedSentence = event.target.value;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-modal--refer {
  .dea-checkbox-list__label {
    @include dea-heading-medium-s;
    margin-bottom: $space-base;
  }

  .dea-checkbox--regular label .dea-checkbox__label {
    @include dea-heading-medium-s;
  }
}
</style>
